import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const MergeQueuesSettingsLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./merge-queues').then(m => m.MergeQueuesSettingsPage),
});
